
const getLabelClass = (status) => {
  switch (status) {
    // NEW
    case "LEG_NEW":
    case "DR_NEW":
    case "RM_NEW":
    case "SCOPED_NEW":
    case "Scoped":
    case "INAB_NEW":
    case "DEMAND_NEW":
      return "label-new";

    // IN PROGRESS
    case "DR_INPRG":
    case "LEG_INPRG":
    case "LEG_INPRCS":
    case "RM_INPRG":
    case "SCOPED_INPRG":
    case "DEMAND_INPRG":
      return "label-inprogress";

    // REVIEW
    case "LEG_REV":
    case "DR_INREV":
    case "LEG_VLDT":
    case "RM_REV":
    case "DR_PEND":
    case "LEG_SIG_PEND":
	case "NEW_DEMAND":
	case "LEG_CUST_REV":
      return "label-review";

    // PARTIAL / PENDING
    case "RM_PRTL":
    case "Pending":
      return "label-pending";

    // COMPLETED / APPROVED
    case "DR_CMPLT":
    case "LEG_CMPLT":
    case "RM_CMPLT":
    case "SCOPED_CMPLT":
    case "INAB_COMPLETED":
	case "Completed":
    case "DEMAND_CMPLT":
	case "active":
	case "Active":
		return "label-complete";
		
		// APPROVED DARK VARIANT
	case "LEG_CUST_APVD":
	case "RM_APVD":
	case "DR_APVD":
	case "INAB_APPROVED":
	case "DEMAND_APVD":
      return "label-approved";

    // REJECTED
    case "LEG_CUST_REJ":
    case "RM_REJ":
    case "DR_REJ":
    case "INAB_REJECTED":
    case "DEMAND_REJ":
    case "DR_REOPEN":
    case "RM_REOPEN":
    case "LEG_DEAL_LOST":
    case "DR_DEAL_LOST":
    case "DEMAND_LOST":
    case "RM_LOST":
    case "N":
	case "Inactive":
	case "in-active":
	case "In-Active":
      return "label-rejected";

    // CONTRACT TYPES
    case "Full-Time":
      return "label-fulltime";
    case "Contractor":
      return "label-contractor";

    // COMMIT TYPES
    case "Hard Commit":
	case "allocated":
	case "Activerm":
      return "label-hardcommit";
    case "Soft Commit":
      return "label-softcommit";
    case "Medium Commit":
      return "label-mediumcommit";

    // CANCELLED / INACTIVE
    case "Cancelled":
      return "label-cancelled";

    // DISCOVERY / QUALIFIED
    case "Discovery":
      return "label-discovery";
    case "Qualified":
	case "not allocated":
      return "label-qualified";

    // REQUEST TYPES
    case "Replace Request":
    case "Y":
      return "label-replace";
    case "Extend Request":
      return "label-extend";
    case "New Add Request":
	case "Below Target":
      return "label-add";
    case "Remove Request":
	case "Above Target":
      return "label-remove";

    // PROJECT DEMAND / WORKBOOK
    case "PROJECT_DEMAND":
    case "IsWorkbook":
      return "label-projectdemand";

    default:
      return "label-default";
  }
};



const getbackgroundColor = (status) => {
	switch (status) {
		case "LEG_NEW":
		case "DR_NEW":
		case "RM_NEW":
		case "SCOPED_NEW":
		case "Scoped":
		case "INAB_NEW":
		case "DEMAND_NEW":
			return "#E5E5FF";
		case "DR_INPRG":
		case "LEG_INPRG":
		case "LEG_INPRCS":
		case "RM_INPRG":
		case "SCOPED_INPRG":
		case "DEMAND_INPRG":
			return "#FFEBC9"; // Change to appropriate color
		case "LEG_REV":
		case "DR_INREV":
		case 'LEG_VLDT':
		case "RM_REV":
		case "DR_PEND":
			return "#E2F5FF"; // Change to appropriate color
		case "RM_PRTL":
			return "#FFF3CD"; // Change to appropriate color
		case "DR_CMPLT":
		case "LEG_CMPLT":
		case "RM_CMPLT":
		case "SCOPED_CMPLT":
		case "INAB_COMPLETED":
		case "DEMAND_CMPLT":
			return "#DEF8EE"; // Change to appropriate color
		case "LEG_CUST_APVD":
		case "RM_APVD":
		case "DR_APVD":
		case "INAB_APPROVED":
		case "DEMAND_APVD":
			return "#314281";
		case "LEG_CUST_REJ":
		case "RM_REJ":
		case "DR_REJ":
		case "INAB_REJECTED":
			return "#FFC7C7";
		case "DR_REOPEN":
			return "#FFC7C7";
		case "RM_REOPEN":
			return "#FFC7C7";
		case "Full-Time":
			return "#FF5C5CCC";
		case "Contractor":
			return "#F6AC19A6";
		case "Active":
			return "#5776E7";
		case "Hard Commit":
			return "rgba(54, 78, 159, 1)";
		case "Soft Commit":
			return "#8ECAE6";
		case "Cancelled":
			return "rgba(28, 28, 28, 0.05)";
		case "Medium Commit":
			return "#FFD166";
		case "Pending":
			return "rgba(226, 245, 255, 1)";
		case "Completed":
			return "rgba(222, 248, 238, 1)";
		case "LEG_CUST_REV":
			return "#FF5C5CCC";
		case "LEG_DEAL_LOST":
		case "DR_DEAL_LOST":
		case "DEMAND_LOST":
		case "RM_LOST":
			return '#FF5C5C'
		case "Replace Request":
		case "Y":
			return "#E8F1FB"
		case "Extend Request":
			return "#FFF8E1"
		case "New Add Request":
			return "#E6F6E6"
		case "Remove Request":
		case "DEMAND_REJ":
		case "N":
			return "#FDECEC"
		case "LEG_SIG_PEND":
			return '#E2F5FF';
		case "Discovery":
			return 'rgba(0, 112, 243, 0.15)';
		case "Qualified":
			return 'rgba(30, 169, 124, 0.15)';
		case "PROJECT_DEMAND":
		case "IsWorkbook":
			return '#ffebee'
		case "NEW_DEMAND":
			return '#E2F5FF'
		default:
			return "black"; // Default color
	}
};

// Function to determine color based on status
// const getStatusColor = (status, variant, statusType, demandTypeId) => {
// 	if (statusType === "stage") {
// 		if (status.includes("DR")) {
// 			//Deal Review
// 			return "#704C9F";
// 		} else if (status.includes("LEG")) {
// 			// Legal
// 			return "#54565B";
// 		} else if (status.includes("RM")) {
// 			// Resource Management
// 			return "#704C9F";
// 		} else if (status.includes("F")) {
// 			// Finance
// 			return "#8E2062";
// 		} else if (status.includes("INAB")) {
// 			// INAB
// 			return "#9747FF";
// 		} else if (status.includes("DEMAND")) {
// 			// DEMAND
// 			return "#9747FF";
// 		} else {
// 			return "#36C5F0"; // Scoped
// 		}
// 	} else if (statusType === "model") {
// 		if (status.includes("DR")) {
// 			//Deal Review
// 			return "rgba(112, 76, 159, 1)";
// 		} else if (status.includes("LEG")) {
// 			// Legal
// 			return "rgba(112, 76, 159, 1)";
// 		} else if (status.includes("SCOPED")) {
// 			// Scoped
// 			return "#36C5F0";
// 		} else if (status.includes("RM")) {
// 			// Resource Management
// 			return "rgba(112, 76, 159, 1)";
// 		} else if (status.includes("DEMAND") || status.includes('Scoped') || status.includes('Discovery') || status.includes('Qualified')) {
// 			if (demandTypeId == "1") {
// 				return "rgba(112, 76, 159, 1)";
// 			} else if (demandTypeId == "2") {
// 				return "rgba(112, 76, 159, 1)";
// 			}
// 			// DEMAND
// 			return "rgba(112, 76, 159, 1)";
// 		}
// 	} else {
// 		switch (status) {
// 			case "LEG_NEW":
// 			case "DR_NEW":
// 			case "RM_NEW":
// 			case "SCOPED_NEW":
// 			case "Scoped":
// 			case "INAB_NEW":
// 			case "DEMAND_NEW":
// 				return variant === "contain" ? "#8A8CD9" : "#364E9F";
// 			case "PROJECT_DEMAND":
// 			case "IsWorkbook":
// 				   return variant === "contain" ? "#E57373" : "#F6C1C8"; 
// 			case "NEW_DEMAND":
// 			case "LEG_SIG_PEND":
// 				return variant === "contain" ? "#59A8D4" : "#59A8D4";
// 			case "DR_INPRG":
// 			case "LEG_INPRG":
// 			case "LEG_INPRCS":
// 			case "RM_INPRG":
// 			case "SCOPED_INPRG":
// 			case "DEMAND_INPRG":
// 				return variant === "contain" ? "#FFAC21" : "#364E9F"; // Change to appropriate color
// 			case "DR_INREV":
// 			case "LEG_REV":
// 			case 'LEG_VLDT':
// 			case "RM_REV":
// 			case "DR_PEND":
// 				return variant === "contain" ? "#59A8D4" : "#59A8D4"; // Change to appropriate color
// 			case "DR_CMPLT":
// 			case "LEG_CMPLT":
// 			case "RM_CMPLT":
// 			case "SCOPED_CMPLT":
// 			case "INAB_COMPLETED":
// 			case "DEMAND_CMPLT":
// 				return variant === "contain" ? "#4AA785" : "#4CAF50"; // Change to appropriate color

// 			case "LEG_CUST_APVD":
// 			case "LEG_CUST_REV":
// 			case "RM_APVD":
// 			case "DR_APVD":
// 			case "INAB_APPROVED":
// 			case "DEMAND_APVD":
// 				return variant === "contain" ? "#FFFFFF" : "#00FFE0";
// 			case "RM_PRTL":
// 				return variant === "contain" ? "#856404" : "#856404";
// 			case "LEG_CUST_REJ":
// 			case "RM_REJ":
// 			case "DR_REJ":
// 			case "INAB_REJECTED":
// 				return variant === "contain" ? "#FF5C5CCC" : "#FF5C5CCC";
// 			case "DR_REOPEN":
// 				return variant === "contain" ? "#FF5C5CCC" : "#FF5C5CCC";
// 			case "RM_REOPEN":
// 				return variant === "contain" ? "#FF5C5CCC" : "#FF5C5CCC";
// 			case "LEG_CUST_REV":
// 				return variant === "contain" ? "#FF5C5CCC" : "#FF5C5CCC";
// 			case "Allocated":
// 				return variant === "contain" ? "#FF5C5CCC" : "#4AA785";
// 			case "Not Allocated":
// 				return variant === "contain" ? "#FF5C5CCC" : "#FF5C5CCC";
// 			case "allocated":
// 				return variant === "contain" ? "#FF5C5CCC" : "#4AA785";
// 			case "not allocated":
// 				return variant === "contain" ? "#FF5C5CCC" : "#FF5C5CCC";
// 			case "in-active":
// 				return variant === "contain" ? "#FF5C5CCC" : "#FF5C5CCC";
// 			case "active":
// 				return variant === "contain" ? "#5776E7" : "#4AA785";
// 			case "Contractor":
// 				return variant === "contain" ? "#FFFFFF" : "#F6AC19A6";
// 			case "Full-Time":
// 				return variant === "contain" ? "#FFFFFF" : "#314281";
// 			case "Active":
// 				return variant === "contain" ? "#FFFFFF" : "rgba(246, 172, 25, 1)";
// 			case "Completed":
// 				return variant === "contain" ? "rgba(74, 167, 133, 1)" : "#4AA785";
// 			case "Pending":
// 				return variant === "contain" ? "rgba(89, 168, 212, 1)" : "#4AA785";
// 			case "Cancelled":
// 				return variant === "contain" ? "rgba(28, 28, 28, 0.4)" : "#4AA785";
// 			case "Activerm":
// 				return variant === "contain" ? "#FFFFFF" : "rgba(246, 172, 25, 1)";
// 			case "Inactive":
// 				return variant === "contain" ? "#FFFFFF" : "#FF5C5CCC";
// 			case "Deal Review":
// 				return "#704C9F";
// 			case "Resource Management":
// 				return "#704C9F";
// 			case "Completedrm":
// 				return "rgba(161, 227, 203, 1)";
// 			case "Pendingrm":
// 				return "rgba(89, 168, 212, 1)";
// 			case "INAB_COMPLETEDrm":
// 				return "rgba(161, 227, 203, 1)";
// 			case "INAB_REJECTEDrm":
// 				return variant === "contain" ? "#FF5C5CCC" : "#FF5C5CCC";
// 			case "INAB_APPROVEDrm":
// 			case "Hard Commit":
// 				return variant === "contain" ? "#FFFFFF" : " rgba(54, 78, 159, 1)"
// 			case "INAB_IN_FLIGHTrm":
// 			case "Medium Commit":
// 				return variant === "contain" ? "#7C5200" : "rgba(246, 172, 25, 1)"
// 			case "INAB_NEWrm":
// 			case "Soft Commit":
// 				return variant === "contain" ? "#023047" : "rgba(89, 168, 212, 1)"
// 			case "Replace Request":
// 			case "Y":
// 				return variant === "contain" ? "#1565C0" : "rgba(89, 168, 212, 1)"
// 			case "Extend Request":
// 				return variant === "contain" ? "#F9A825" : "rgba(89, 168, 212, 1)"
// 			case "Remove Request":
// 			case "DEMAND_REJ":
// 			case "N":
// 				return variant === "contain" ? "#C62828" : "rgba(89, 168, 212, 1)"
// 			case "New Add Request":
// 				return variant === "contain" ? "#2E7D32" : "rgba(89, 168, 212, 1)"
// 			case "Discovery":
// 				return variant === "contain" ? "#0070F3" : "rgba(89, 168, 212, 1)"
// 			case "Qualified":
// 				return variant === "contain" ? "#1EA97C" : "rgba(89, 168, 212, 1)"
// 			default:
// 				return "white"; // Default color
// 		}
// 	}
// };

const getStatusTypeClass = (status, statusType) => {
  if (statusType === "stage") {
    if (status.includes("DR")) return "label-stage-dr";
    if (status.includes("LEG")) return "label-stage-leg";
    if (status.includes("RM")) return "label-stage-rm";
    if (status.includes("F")) return "label-stage-fin";
    if (status.includes("INAB")) return "label-stage-inab";
    if (status.includes("DEMAND")) return "label-stage-demand";
    return "label-stage-scoped"; // fallback
  }

  if (statusType === "model") {
    if (status.includes("DR")) return "label-model-dr";
    if (status.includes("LEG")) return "label-model-leg";
    if (status.includes("SCOPED")) return "label-model-scoped";
    if (status.includes("RM")) return "label-model-rm";
    if (
      status.includes("DEMAND") ||
      status.includes("Scoped") ||
      status.includes("Discovery") ||
      status.includes("Qualified")
    )
      return "label-model-demand";
      return "label-model-demand";
  }

  return ""; // no extra class
};


const adjustAlpha = (color, alpha = 0.15) => {
  if (color.startsWith("#")) {
    const hex = color.replace("#", "");
    const bigint = parseInt(hex, 16);
    const r = (bigint >> 16) & 255;
    const g = (bigint >> 8) & 255;
    const b = bigint & 255;
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  }
  return color.replace(/rgba?\(([^)]+)\)/, (match, inner) => {
    const [r, g, b] = inner.split(",").map(Number);
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  });
};

const resolveBaseColor = (status, statusType, demandTypeId) => {
  // ---- Stage ----
  if (statusType === "stage") {
    if (status.includes("DR")) return "#704C9F";
    if (status.includes("LEG")) return "#54565B";
    if (status.includes("RM")) return "#704C9F";
    if (status.includes("F")) return "#8E2062";
    if (status.includes("INAB")) return "#9747FF";
    if (status.includes("DEMAND")) return "#9747FF";
    return "#36C5F0"; // Scoped default
  }

  // ---- Model ----
  if (statusType === "model") {
    if (status.includes("DR")) return "rgba(112, 76, 159, 1)";
    if (status.includes("LEG")) return "rgba(112, 76, 159, 1)";
    if (status.includes("RM")) return "rgba(112, 76, 159, 1)";
    if (status.includes("SCOPED")) return "#36C5F0";
    if (
      status.includes("DEMAND") ||
      status.includes("Scoped") ||
      status.includes("Discovery") ||
      status.includes("Qualified")
    ) {
      if (["1", "2"].includes(demandTypeId)) return "rgba(112, 76, 159, 1)";
      return "rgba(112, 76, 159, 1)";
    }
  }

  // ---- General Status ----
  const map = {
    LEG_NEW: "#8A8CD9",
    DR_NEW: "#8A8CD9",
    RM_NEW: "#8A8CD9",
    SCOPED_NEW: "#8A8CD9",
    Scoped: "#8A8CD9",
    INAB_NEW: "#8A8CD9",
    DEMAND_NEW: "#8A8CD9",

    PROJECT_DEMAND: "#E57373",
    IsWorkbook: "#E57373",

    NEW_DEMAND: "#59A8D4",
    LEG_SIG_PEND: "#59A8D4",

    DR_INPRG: "#FFAC21",
    LEG_INPRG: "#FFAC21",
    LEG_INPRCS: "#FFAC21",
    RM_INPRG: "#FFAC21",
    SCOPED_INPRG: "#FFAC21",
    DEMAND_INPRG: "#FFAC21",

    DR_INREV: "#59A8D4",
    LEG_REV: "#59A8D4",
    LEG_VLDT: "#59A8D4",
    RM_REV: "#59A8D4",
    DR_PEND: "#59A8D4",

    DR_CMPLT: "#4AA785",
    LEG_CMPLT: "#4AA785",
    RM_CMPLT: "#4AA785",
    SCOPED_CMPLT: "#4AA785",
    INAB_COMPLETED: "#4AA785",
    DEMAND_CMPLT: "#4AA785",

    LEG_CUST_APVD: "#00FFE0",
    LEG_CUST_REV: "#00FFE0",
    RM_APVD: "#00FFE0",
    DR_APVD: "#00FFE0",
    INAB_APPROVED: "#00FFE0",
    DEMAND_APVD: "#00FFE0",

    RM_PRTL: "#856404",

    LEG_CUST_REJ: "#FF5C5C",
    RM_REJ: "#FF5C5C",
    DR_REJ: "#FF5C5C",
    INAB_REJECTED: "#FF5C5C",

    DR_REOPEN: "#FF5C5C",
    RM_REOPEN: "#FF5C5C",
    LEG_CUST_REV2: "#FF5C5C",

    Allocated: "#4AA785",
    "Not Allocated": "#FF5C5C",
    allocated: "#4AA785",
    "not allocated": "#FF5C5C",
    "in-active": "#FF5C5C",
    active: "#5776E7",

    Contractor: "#F6AC19",
    "Full-Time": "#314281",

    Active: "#F6AC19",
    Completed: "#4AA785",
    Pending: "#59A8D4",
    Cancelled: "rgba(28, 28, 28, 0.4)",
    Activerm: "#F6AC19",
    Inactive: "#FF5C5C",

    "Deal Review": "#704C9F",
    "Resource Management": "#704C9F",

    Completedrm: "rgba(161, 227, 203, 1)",
    Pendingrm: "rgba(89, 168, 212, 1)",
    INAB_COMPLETEDrm: "rgba(161, 227, 203, 1)",
    INAB_REJECTEDrm: "#FF5C5C",
    INAB_APPROVEDrm: "rgba(54, 78, 159, 1)",

    "Hard Commit": "rgba(54, 78, 159, 1)",
    "Medium Commit": "rgba(246, 172, 25, 1)",
    "Soft Commit": "rgba(89, 168, 212, 1)",

    "Replace Request": "rgba(89, 168, 212, 1)",
    Y: "rgba(89, 168, 212, 1)",
    "Extend Request": "rgba(89, 168, 212, 1)",
    "Remove Request": "rgba(89, 168, 212, 1)",
	"Above Target": "rgba(89, 168, 212, 1)",
    DEMAND_REJ: "#FF5C5C",
    N: "#FF5C5C",
    "New Add Request": "rgba(89, 168, 212, 1)",
	"Below Target": "rgba(89, 168, 212, 1)",
    Discovery: "#0070F3",
    Qualified: "#1EA97C",
  };

  return map[status] || "white";
};


const getStatusColor = (status, variant, statusType, demandTypeId, isDarkMode = false) => {
  // 1️⃣ Resolve base color depending on stage/model/normal
  const base = resolveBaseColor(status, statusType, demandTypeId);

  // 2️⃣ Build readable color set
  const isContain = variant === "contain";

  const text = isContain
    ? isDarkMode
      ? "#fff"
      : base
    : base;

  return { text };
};





const StatusBadge = ({ statusType = "", status, variant = "", color, demandTypeId = "" }) => {
	
	if (!status || typeof status !== "string") {
		return <div className="text-error">Error: Invalid status</div>;
	}
	const badgeClass =  getLabelClass(status);

	const bgColor =
		color ||
		(variant === "contain" ? "contain" : "!bg-transparent");
	const statusColor = statusType ? getStatusTypeClass(status, statusType) : "";
	const text = getStatusText(status, variant, statusType, demandTypeId);

	// const { text:statusColor } = getStatusColor(status, variant, statusType, demandTypeId, mode === 'dark');

	return (
		<div
			className={`inline-flex items-center justify-center px-2 py-1.5 rounded-full ${badgeClass} ${bgColor} ${statusColor}`}
		>
			{variant === "contain" ? (
				<p
					className="text-[12px] font-medium font-sans leading-tight whitespace-nowrap overflow-hidden text-ellipsis"
				>
					{text}
				</p>
			) : (
				<div className="inline-flex items-center justify-center gap-2">
					<div
						className="w-1.5 h-1.5 rounded-full flex-shrink-0 bg-current"
					></div>
					<p
						className="text-[12px] font-medium font-sans leading-none"
					>
						{text}
					</p>
				</div>
			)}
		</div>

	);
};


export const getStatusText = (status, variant, statusType, demandTypeId) => {
	if (statusType === "stage") {
		if (status.includes("DR")) {
			return "Deal Review";
		} else if (status.includes("LEG")) {
			return "Legal";
		} else if (status.includes("RM")) {
			return "RM";
		} else if (status.includes("FIN")) {
			return "Finance";
		} else if (status.includes('SCOPED')) {
			return "Scoped";
		} else if (status.includes('INAB')) {
			return "iNAB";
		} else if (status.includes("DEAL")) {
			return "Deal Review"
		}
		else if (status.includes('DEMAND')) {
			return "Demand Pipeline";
		} else {
			return status;
		}
	} else if (statusType === "model") {
		if (status.includes("DR")) {
			return "Deal Review";
		} else if (status.includes("LEGR")) {
			return "Legal Review";
		} else if (status.includes("LEG")) {
			return "Legal";
		} else if (status.includes("SCOPED")) {
			return "Scoped";
		} else if (status.includes("RM")) {
			return "RM";
		} else if (status.includes('DEMAND') || status.includes('Scoped') || status.includes('Discovery') || status.includes('Qualified')) {
			if (demandTypeId == "1") {
				return "Preliminary Staffing Demand";
			} else if (demandTypeId == "2") {
				return "Project Demand";
			}
			return "Other Demand";
		}
	} else {
		switch (status) {
			case "LEG_NEW":
			case "DR_NEW":
			case "RM_NEW":
			case "INAB_NEW":
			case "DEMAND_NEW":
				return variant === "contain" ? "New" : "Proposal";
			case "DR_INPRG":
			case "RM_INPRG":
			case "LEG_INPRG":
			case "DEMAND_INPRG":
				return variant === "contain" ? "In-Progress" : "In Progress";
			case "LEG_INPRCS":
				return variant === "contain" ? "In-Process" : "In Process";
			case "LEG_REV":
			case "DR_INREV":
			case "RM_REV":
				return variant === "contain" ? "Review" : "In Review";
			case "DR_CMPLT":
			case "INAB_COMPLETED":
			case "DEMAND_CMPLT":
				return variant === "contain" ? "Completed" : "Completed";
			case "LEG_CMPLT":
				return variant === "contain" ? "Completed" : "Completed";
			case "RM_CMPLT":
				return variant === "contain" ? "Complete" : "Completed";
			case "LEG_VLDT":
				return "In Validation";
			case "LEG_CUST_REV":
				return "Customer Review";
			case "LEG_SIG_PEND":
				return "Pending Sign";
			case "LEG_CUST_APVD":
			case "RM_APVD":
			case "DR_APVD":
			case "INAB_APPROVED":
			case "DEMAND_APVD":
				return "Approved";
			case "LEG_CUST_REJ":
			case "RM_REJ":
			case "DR_REJ":
			case "INAB_REJECTED":
				return "Rejected";
			case "DR_PEND":
				return "Pending";
			case "DR_REOPEN":
				return "Re-Open";
			case "RM_REOPEN":
				return "Re-Open";
			case "Allocated":
				return "Allocated";
			case "Deal Review":
				return "Deal Review";
			case "Resource Management":
				return "Resource Management";
			case "Active":
				return "Active";
			case "Activerm":
				return "In-Progress";
			case "SCOPED_NEW":
				return "New";
			case "SCOPED_INPRG":
				return "In Progress";
			case "SCOPED_CMPLT":
				return "Completed";
			case "Completedrm":
				return "Completed";
			case "Pendingrm":
				return "Pending";
			case "INAB_COMPLETEDrm":
				return "Completed";
			case "INAB_REJECTEDrm":
				return "Rejected";
			case "INAB_APPROVEDrm":
				return "Approved";
			case "INAB_NEWrm":
				return "New";
			case "INAB_IN_FLIGHTrm":
				return "In Flight";
			case "LEG_DEAL_LOST":
			case "DR_DEAL_LOST":
			case "DEMAND_LOST":
			case "RM_LOST":
				return "Deal Lost"
			case "RM_PRTL":
				return "Partially Complete";
			case "Medium Commit":
				return "medium"
			case "Soft Commit":
				return "soft"
			case "Replace Request":
				return "Replace Request"
			case "Extend Request":
				return "Extend Request"
			case "Remove Request":
				return "Remove Request"
			case "New Add Request":
				return "New Request"
			case "DEMAND_REJ":
				return "Rejected"
			case "N":
				return "Existing Resource"
			case "Y":
				return "New Resource"
			case "Scoped":
				return "Scoped"
			case "NEW_DEMAND":
				return "New Demand"
			case "PROJECT_DEMAND":
				return "Project Demand"
			case "IsWorkbook":
				return "Playground WorkBook Deal"
			case "Below Target":
				return "Below Target"
			case "Above Target":
				return "Above Target"
			// case "PG_NEW":
			// 	return "Playground New"
			default:
				return status; // Default color
		}
	}
};

export default StatusBadge;
